<div class="card-body" *ngIf="active" [ngClass]="{'borderless': borderless}">
    <div class="tab-pane fade show active">
        <ng-content></ng-content>
    </div>
</div>